"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasAdvertisingConsent = exports.initConsent = exports.hubspotAPI = void 0;
require("./global");
require("./hubspot");
var api_1 = require("./api");
Object.defineProperty(exports, "hubspotAPI", { enumerable: true, get: function () { return api_1.hubspotAPI; } });
var init_consent_1 = require("./init-consent");
Object.defineProperty(exports, "initConsent", { enumerable: true, get: function () { return init_consent_1.initConsent; } });
var consent_wrapper_1 = require("./consent-wrapper");
Object.defineProperty(exports, "hasAdvertisingConsent", { enumerable: true, get: function () { return consent_wrapper_1.hasAdvertisingConsent; } });
